import script from "./SettingHelper.vue?vue&type=script&setup=true&lang=ts"
export * from "./SettingHelper.vue?vue&type=script&setup=true&lang=ts"

import "./SettingHelper.vue?vue&type=style&index=0&id=285bbccf&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-285bbccf"]])

export default __exports__